export const defaultLocation = { latitude: 40.7128, longitude: -73.9808 }; // 25 Jackson Street, New York, NY 10002, United States of America
